import React, { useState } from 'react';

const MapSection = () => {
  const [activePin, setActivePin] = useState(null);

  const locations = [
  { id: 1, name: 'Hovedkontor', address: 'Storgata 47, Oslo', x: '52%', y: '44%', type: 'main' },
  { id: 2, name: 'Supportkontor', address: 'Bryggen 12, Bergen', x: '22%', y: '58%', type: 'support' },
  { id: 3, name: 'Nordkontor', address: 'Storgata 5, Tromsø', x: '58%', y: '12%', type: 'support' }];


  return (
    <section style={{
      background: '#050A12',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Section header */}
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '60px', flexWrap: 'wrap', gap: '24px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <div style={{ width: '28px', height: '1px', background: '#E8941A' }} />
              <span style={{ fontFamily: 'monospace', fontSize: '0.6rem', letterSpacing: '0.3em', color: '#E8941A', textTransform: 'uppercase' }}>Våre kontorer</span>
            </div>
            <div style={{
              fontFamily: '"Arial Black", sans-serif',
              fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
              fontWeight: 900, color: '#EEF0F2',
              letterSpacing: '-0.05em', textTransform: 'uppercase',
              lineHeight: 0.88
            }}>FINN OSS</div>
            <div style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: 'clamp(1.25rem, 2.5vw, 2rem)',
              color: '#3B6FD4', lineHeight: 1, marginTop: '4px'
            }}>over hele landet.</div>
          </div>
          <div style={{
            border: '1px solid rgba(59,111,212,0.25)',
            padding: '16px 24px',
            transform: 'rotate(1deg)',
            maxWidth: '260px'
          }}>
            <div style={{ fontFamily: 'monospace', fontSize: '0.55rem', letterSpacing: '0.2em', color: 'rgba(59,111,212,0.6)', textTransform: 'uppercase', marginBottom: '8px' }}>Åpningstider</div>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '0.85rem', color: 'rgba(238,240,242,0.6)', lineHeight: 1.6 }}>
              Man–Fre: 08:00–17:00<br />
              Lørdag: 10:00–14:00<br />
              Søndag: Stengt
            </div>
          </div>
        </div>

        {/* Map container */}
        <div style={{ position: 'relative', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', overflow: 'hidden' }}>
          {/* Norway map image */}
          <div style={{ position: 'relative', height: '480px' }}>
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_17255ffbb-1772188997213.png"
              alt="Aerial satellite view of Norwegian landscape with fjords, mountains and coastal terrain"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', filter: 'brightness(0.3) contrast(1.3) saturate(0.4) hue-rotate(200deg)' }} />
            
            {/* Grid overlay */}
            <div style={{
              position: 'absolute', inset: 0,
              backgroundImage: 'linear-gradient(rgba(59,111,212,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(59,111,212,0.08) 1px, transparent 1px)',
              backgroundSize: '60px 60px'
            }} />

            {/* Location pins */}
            {locations?.map((loc) =>
            <div
              key={loc?.id}
              onClick={() => setActivePin(activePin === loc?.id ? null : loc?.id)}
              style={{
                position: 'absolute',
                left: loc?.x, top: loc?.y,
                transform: 'translate(-50%, -50%)',
                cursor: 'pointer',
                zIndex: 10
              }}>
              
                {/* Pin */}
                <div style={{
                width: loc?.type === 'main' ? '20px' : '14px',
                height: loc?.type === 'main' ? '20px' : '14px',
                background: loc?.type === 'main' ? '#E8941A' : '#3B6FD4',
                border: `2px solid ${loc?.type === 'main' ? 'rgba(232,148,26,0.4)' : 'rgba(59,111,212,0.4)'}`,
                borderRadius: '50%',
                boxShadow: `0 0 ${loc?.type === 'main' ? '20px' : '12px'} ${loc?.type === 'main' ? 'rgba(232,148,26,0.5)' : 'rgba(59,111,212,0.5)'}`,
                transition: 'transform 0.2s',
                transform: activePin === loc?.id ? 'scale(1.4)' : 'scale(1)'
              }} />
                {/* Tooltip */}
                {activePin === loc?.id &&
              <div style={{
                position: 'absolute',
                bottom: '28px', left: '50%',
                transform: 'translateX(-50%)',
                background: '#050A12',
                border: `1px solid ${loc?.type === 'main' ? '#E8941A' : '#3B6FD4'}`,
                padding: '10px 14px',
                whiteSpace: 'nowrap',
                zIndex: 20
              }}>
                    <div style={{ fontFamily: '"Arial Black", sans-serif', fontSize: '0.75rem', fontWeight: 900, color: '#EEF0F2', letterSpacing: '-0.02em', textTransform: 'uppercase' }}>{loc?.name}</div>
                    <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '0.7rem', color: 'rgba(238,240,242,0.5)', marginTop: '2px' }}>{loc?.address}</div>
                  </div>
              }
              </div>
            )}

            {/* Corner label */}
            <div style={{
              position: 'absolute', bottom: '16px', right: '16px',
              fontFamily: 'monospace', fontSize: '0.55rem',
              letterSpacing: '0.2em', color: 'rgba(59,111,212,0.5)',
              textTransform: 'uppercase'
            }}>NordPass — Kontoroversikt 2026</div>
          </div>

          {/* Location list below map */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            {locations?.map((loc, i) =>
            <div
              key={loc?.id}
              onClick={() => setActivePin(activePin === loc?.id ? null : loc?.id)}
              style={{
                padding: '24px',
                borderRight: i < 2 ? '1px solid rgba(255,255,255,0.06)' : 'none',
                cursor: 'pointer',
                background: activePin === loc?.id ? 'rgba(59,111,212,0.08)' : 'transparent',
                transition: 'background 0.2s'
              }}>
              
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <div style={{
                  width: '8px', height: '8px',
                  background: loc?.type === 'main' ? '#E8941A' : '#3B6FD4',
                  borderRadius: '50%', flexShrink: 0
                }} />
                  <div style={{ fontFamily: '"Arial Black", sans-serif', fontSize: '0.8rem', fontWeight: 900, color: '#EEF0F2', letterSpacing: '-0.02em', textTransform: 'uppercase' }}>{loc?.name}</div>
                </div>
                <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '0.8rem', color: 'rgba(238,240,242,0.5)', lineHeight: 1.5 }}>{loc?.address}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default MapSection;